/**
 * Contact page: the reason cards preselect a topic in the form, the message placeholder follows
 * the topic, the thank-you title greets by first name, and the Google map loads only on click.
 * Loaded by several sections, so it runs once.
 */
(function () {
  if (window.poianaContactReady) return;
  window.poianaContactReady = true;

  var NAME_KEY = 'poiana-contact-name';

  function sync() {
    var checked = document.querySelector('[data-topic-radio]:checked');
    var topic = checked ? checked.value : '';
    var message = document.querySelector('[data-contact-message]');
    if (message && checked) message.placeholder = checked.dataset.placeholder || message.dataset.placeholder;
    document.querySelectorAll('[data-topic]').forEach(function (card) {
      card.classList.toggle('is-active', card.dataset.topic === topic);
    });
  }

  document.addEventListener('click', function (event) {
    var card = event.target.closest('[data-topic]');
    if (card) {
      // The link still scrolls to the form; this only picks the matching topic.
      document.querySelectorAll('[data-topic-radio]').forEach(function (radio) {
        if (radio.value === card.dataset.topic) radio.checked = true;
      });
      sync();
      return;
    }

    var load = event.target.closest('[data-map-load]');
    if (load) {
      event.preventDefault();
      var frame = document.createElement('iframe');
      frame.src = 'https://maps.google.com/maps?q=' + encodeURIComponent(load.dataset.query) + '&z=' + (load.dataset.zoom || 13) + '&output=embed';
      frame.title = load.dataset.title;
      frame.loading = 'lazy';
      frame.referrerPolicy = 'no-referrer-when-downgrade';
      load.closest('[data-map]').replaceChildren(frame);
    }
  });

  document.addEventListener('change', function (event) {
    if (event.target.matches('[data-topic-radio]')) sync();
  });

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('[data-contact-form]');
    if (!form) return;
    var name = form.querySelector('[name="contact[name]"]');
    try {
      sessionStorage.setItem(NAME_KEY, name ? name.value.trim().split(/\s+/)[0] : '');
    } catch (error) {}
  });

  var thanks = document.querySelector('[data-contact-thanks]');
  if (thanks) {
    var first = '';
    try {
      first = sessionStorage.getItem(NAME_KEY) || '';
      sessionStorage.removeItem(NAME_KEY);
    } catch (error) {}
    if (first) thanks.textContent = thanks.dataset.template.replace('[name]', first);
  }

  sync();
})();
